
define('ldsh!modules/editor/templates/property_boxes/idclass', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class=" ed-modal-content ed-opt-content ed-tab-content active">\n  <form role="form" action="">\n    <div class="col one-third">\n      <div class="ed-form-group">\n        <label for="" data-i18n="editor.idclass.id"></label>\n        <input class="ed-form-control" type="text" data-property="id" data-validation-message="id">\n      </div>\n\n      <div class="ed-form-group">\n        <label for="" data-i18n="editor.idclass.className"></label>\n       <input type="text" data-property="className" class="ed-form-control" />\n      </div>\n    </div>\n  </form>\n</div>\n';

}
return __p
};});

